import React, { useState } from 'react';
import { Check, UserCircle, ChevronDownIcon } from 'lucide-react';
import { FadeIn } from './FadeIn';
import { AnimatePresence, motion } from 'framer-motion';
const artists = [{
  name: 'Artista 1',
  specialty: 'Realismo B&N',
  initial: 'A1'
}, {
  name: 'Artista 2',
  specialty: 'Realismo Color',
  initial: 'A2'
}, {
  name: 'Artista 3',
  specialty: 'Blackwork',
  initial: 'A3'
}, {
  name: 'Artista 4',
  specialty: 'Fine Line',
  initial: 'A4'
}, {
  name: 'Artista 5',
  specialty: 'Neo-Tradicional',
  initial: 'A5'
}];
export function About() {
  const [showTeam, setShowTeam] = useState(false);
  return <section id="about" className="py-[70px] px-[25px] md:py-[80px] md:px-[40px] lg:py-[100px] lg:px-[60px] bg-dark" data-id="element-20">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-[50px] md:gap-[80px] items-center max-w-[1200px] mx-auto" data-id="element-21">
        <FadeIn className="relative" data-id="element-22">
          <div className="absolute -top-[15px] -left-[15px] right-[15px] -bottom-[15px] border border-gold/30 z-0" data-id="element-23"></div>
          <div className="absolute inset-0 bg-gradient-to-br from-gold/10 to-transparent z-10" data-id="element-24"></div>

          <img src="https://cdn.magicpatterns.com/uploads/ht7NXzA2zxvKyp3WaevAxx/IMG_3110.jpg" alt="Artista de SOLIDO TATTOO STUDIO" className="w-full h-[350px] md:h-[500px] object-cover relative z-20" data-id="element-25" />

          <div className="absolute -bottom-[20px] -right-[20px] w-[110px] h-[110px] bg-gold flex flex-col items-center justify-center z-30" data-id="element-26">
            <span className="font-cinzel text-[2rem] font-black text-black leading-none" data-id="element-27">
              15+
            </span>
            <span className="text-[0.5rem] tracking-[2px] uppercase text-black text-center font-bold" data-id="element-28">
              AÑOS DE ARTE
            </span>
          </div>
        </FadeIn>

        <FadeIn data-id="element-29">
          <span className="text-[0.6rem] tracking-[6px] uppercase text-gold font-semibold block mb-5" data-id="element-30">
            Sobre el Artista
          </span>
          <h2 className="font-cinzel text-[2.2rem] text-white uppercase tracking-[3px] leading-[1.2] mb-[25px]" data-id="element-31">
            Más de <span className="text-gold" data-id="element-32">15 Años</span>
            <br data-id="element-33" />
            Haciendo Arte
          </h2>

          <p className="text-gray text-[0.95rem] leading-[1.9] mb-[15px] tracking-[0.3px]" data-id="element-34">
            Con{' '}
            <strong className="text-white font-semibold" data-id="element-35">
              más de 15 años de experiencia
            </strong>{' '}
            perfeccionando el arte del tatuaje de forma autodidacta, cada trazo
            refleja años de práctica, dedicación y una pasión que nació desde el
            primer día.
          </p>
          <p className="text-gray text-[0.95rem] leading-[1.9] mb-[15px] tracking-[0.3px]" data-id="element-36">
            Desde 2010 tatúo con una filosofía clara: . En 2022, traje esa
            visión a Miami, donde SOLIDO TATTOO STUDIO se convirtió en un
            referente del realismo y la calidad artística en la ciudad.
          </p>
          <p className="text-gray text-[0.95rem] leading-[1.9] mb-[15px] tracking-[0.3px]" data-id="element-37">
            Todo lo que sé lo aprendí{' '}
            <strong className="text-white font-semibold" data-id="element-38">
              en la calle, en la práctica y con disciplina
            </strong>
            . Entiendo luz, sombra, proporción y composición porque llevo años
            estudiándolos con mis propias manos.
          </p>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-[15px] mt-[30px]" data-id="element-39">
            {['Realismo B&N Premium', 'Realismo a Color', 'Diseño Personalizado', 'Todos los Estilos', 'Estudio en Miami', 'Artista Autodidacta'].map((feature, i) => <div key={i} className="flex items-center gap-2.5 text-[0.8rem] text-gray tracking-[1px]" data-id="element-40">
                <Check size={14} className="text-gold" data-id="element-41" />
                <span data-id="element-42">{feature}</span>
              </div>)}
          </div>
        </FadeIn>
      </div>

      <div className="max-w-[1200px] mx-auto mt-[60px] text-center" data-id="element-43">
        <button onClick={() => setShowTeam(!showTeam)} className="inline-flex items-center gap-3 bg-transparent text-white py-4 px-10 font-cinzel text-[0.75rem] font-bold tracking-[4px] uppercase border border-gold/30 transition-all duration-300 hover:border-gold hover:text-gold hover:-translate-y-0.5 hover:shadow-[0_10px_40px_rgba(201,168,76,0.2)]" data-id="element-44">
          Nuestro Equipo de Artistas
          <ChevronDownIcon size={18} className={`text-gold transition-transform duration-300 ${showTeam ? 'rotate-180' : ''}`} data-id="element-45" />
        </button>

        <AnimatePresence data-id="element-46">
          {showTeam && <motion.div initial={{
          opacity: 0,
          height: 0
        }} animate={{
          opacity: 1,
          height: 'auto'
        }} exit={{
          opacity: 0,
          height: 0
        }} transition={{
          duration: 0.5,
          ease: 'easeInOut'
        }} className="overflow-hidden" data-id="element-47">
              <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-5 gap-[20px] mt-[50px]" data-id="element-48">
                {artists.map((artist, i) => <motion.div key={i} initial={{
              opacity: 0,
              y: 20
            }} animate={{
              opacity: 1,
              y: 0
            }} transition={{
              delay: i * 0.1,
              duration: 0.4
            }} className="bg-dark-2 border border-gold/10 p-[25px_15px] text-center group transition-all duration-300 hover:border-gold/30 hover:-translate-y-1" data-id="element-49">
                    <div className="w-[80px] h-[80px] rounded-full bg-dark-3 border-2 border-gold/20 flex items-center justify-center mx-auto mb-4 group-hover:border-gold/50 transition-colors duration-300" data-id="element-50">
                      <UserCircle size={36} className="text-gold/30" data-id="element-51" />
                    </div>
                    <div className="font-cinzel text-[0.8rem] text-white uppercase tracking-[2px] mb-1" data-id="element-52">
                      {artist.name}
                    </div>
                    <div className="text-[0.65rem] text-gold tracking-[1px]" data-id="element-53">
                      {artist.specialty}
                    </div>
                  </motion.div>)}
              </div>
            </motion.div>}
        </AnimatePresence>
      </div>
    </section>;
}